module.exports = "/images/4cc8cb423c77827663e51c114561d6a0.png";